module.exports = __webpack_public_path__ + "static/img/3.f59c188.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/3.png
// module id = Vj3s
// module chunks = 0